import React, { useContext, useState } from 'react';
import FormDataContext from 'integrations/contexts/FormDataContext';

import { Input } from 'components/bootstrap';
import Select from 'components/common/Select';

import FormAdvancedOptions from './FormAdvancedOptions';
import type { ErrorMessageType, HandleFieldUpdateType, HandleSubmitType } from './types';

import FormWrap from '../common/FormWrap';

interface Props {
  onSubmit: HandleSubmitType;
  onChange: HandleFieldUpdateType;
}

const StepSubscribe = ({ onSubmit, onChange }: Props) => {
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState<ErrorMessageType>(null);
  const [azureBatchSizeError, setAzureBatchSizeError] = useState<boolean>(false);
  const [azureWaitTimeError, setAzureWaitTimeError] = useState<boolean>(false);
  const { azureBatchSize, azureWaitTime, contentTypes } = formData;
  const availableContent = [
    { label: 'Azure Services', value: 'AZURE_SERVICES' },
    { label: 'JSON Array', value: 'JSON_ARRAY' },
    { label: 'Raw Text/Single JSON document', value: 'TEXT' },
    { label: 'GELF (Newline Delimited)', value: 'GELF_BATCH' },
    { label: 'Text (Newline Delimited)', value: 'TEXT_BATCH' },
  ];
  const [contentTypesState, setContentTypesState] = useState<string>(contentTypes.value || '');
  const [contentTypeVal] = useState(false);

  const handleSubmit = () => {
    formData.contentTypes.value = contentTypesState;
    let error = false;

    if (azureBatchSize.value < 1 || azureBatchSize.value > 1000) {
      error = true;
      setAzureBatchSizeError(true);
    }

    if (azureWaitTime.value < 1 || azureWaitTime.value > 30) {
      error = true;
      setAzureWaitTimeError(true);
    }

    if (!error) {
      setFormError(null);
      onSubmit();
    }
  };

  return (
    <FormWrap onSubmit={handleSubmit} buttonContent="Proceed" title="" error={formError} description="">
      <label className="control-label" htmlFor="contents">
        Content Type
      </label>
      <Select
        name="content_types"
        id="contentTypes"
        onChange={(selected: string) => setContentTypesState(selected)}
        options={availableContent}
        value={contentTypesState || ''}
      />

      {contentTypeVal && contentTypesState.length === 0 && <label htmlFor="contentTypes">Select at least one</label>}

      <span className="help-block">The content type of your log files.</span>
      <Input
        id="azureBatchSize"
        name="azureBatchSize"
        type="number"
        value={azureBatchSize.value || azureBatchSize.defaultValue || ''}
        min="10"
        max="20000"
        onChange={onChange}
        required
        help="The Maximum message count received from Event Hub at once. The input will store checkpoints once per batch."
        label="Maximum Batch Size"
      />
      {azureBatchSizeError && (
        <span>
          {' '}
          <strong>The Maximum Batch Size must be greater than 1.</strong>
        </span>
      )}
      <Input
        id="azureWaitTime"
        name="azureWaitTime"
        type="number"
        value={azureWaitTime.value || azureWaitTime.defaultValue || ''}
        min="1"
        max="30"
        onChange={onChange}
        required
        help="The maximum amount of time to wait for the Maximum Batch Size to be reached. The average wait time is 3 minutes"
        label="Maximum Wait Time"
      />
      {azureWaitTimeError && (
        <span>
          {' '}
          <strong>The wait time can be between 1 to 30</strong>
        </span>
      )}
      <FormAdvancedOptions onChange={onChange} />
    </FormWrap>
  );
};

export default StepSubscribe;
